module.exports = __webpack_public_path__ + "static/media/main idea.c5083dd1.mp3";